/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DocumentRedactionInlineContent } from './DocumentRedactionInlineContent';
import type { EmployeeLdap } from './EmployeeLdap';

export type DocumentRedactionResponse = {
    id: string;
    status: DocumentRedactionResponse.status;
    can_view: boolean;
    can_manage: boolean;
    mask_size: DocumentRedactionResponse.mask_size;
    text?: (string | null);
    content?: (DocumentRedactionInlineContent | null);
    character_count?: (number | null);
    allowed_employee_ids?: (Array<string> | null);
    allowed_employees?: (Array<EmployeeLdap> | null);
    created_at?: (string | null);
    updated_at?: (string | null);
};

export namespace DocumentRedactionResponse {

    export enum status {
        DRAFT = 'draft',
        ACTIVE = 'active',
        PENDING_REMOVAL = 'pending_removal',
        REMOVED = 'removed',
    }

    export enum mask_size {
        SHORT = 'short',
        MEDIUM = 'medium',
        LONG = 'long',
    }


}

